import api from './index'
import { axios } from '@/utils/request'

export function login (params) {
  return axios({
    url: api.loginUrl,
    method: 'post',
    data: params
  })
}

export function getProjectInfo (projectHashId, token) {
  return axios({
    url: api.projectInfo + projectHashId,
    headers: {'AUTH': token},
    method: 'get'
  })
}

export function getTicketDay (hashId) {
  return axios.get(api.ticketDay + hashId + '/ticket/duration/day')
}
export function getTicketWeek (hashId) {
  return axios.get(api.ticketWeek + hashId + '/ticket/duration/week')
}
export function getTicketMonth (hashId) {
  return axios.get(api.ticketMonth + hashId + '/ticket/duration/month')
}

export function getMetric (hashId) {
  return axios.get(api.metricUrl + hashId)
}

export function getSeries (params, token) {
  return axios({
    url: api.seriesUrl,
    headers: {'AUTH': token},
    method: 'post',
    data: JSON.stringify(params)
  })
}

export function getLatestAlarm (hashId) {
  return axios.get(api.latestAlarm + hashId)
}

export function getBoxMetric (hashId) {
  return axios({
    url: api.boxMetric + hashId + '/distribution',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/metric.js